"use strict";

(function () {
  'use strict';

  function DashboardCtrl($window, $state, LoginService, TripService, ConnectionsService, LRNotification, $timeout) {
    var vm = this;

    var _loadTrips = function _loadTrips(skipLoading) {
      if (!skipLoading) {
        vm.tripsLoading = true;
      }

      TripService.getList().then(function (data) {
        vm.trips = TripService.groupByStatus(data);
        vm.tripsLoading = false;
      }, function () {
        vm.tripsLoading = false;
      });
    };

    this.pendingDesc = 'Connections allow you to view and manage your trips from each Vacation Manager within LiveStay.';

    this.approve = function (partner) {
      vm.approving = partner.adminCustDataId;
      ConnectionsService.approve(partner.adminCustDataId).then(function () {
        LRNotification.success('Connected successfully with ' + partner.companyName, 3500);
        partner.dateApproved = new Date();

        _loadTrips(true);

        vm.approving = false;
      }, function () {
        vm.approving = false;
      });
    };

    this.$onInit = function () {
      vm.approving = false;
      ConnectionsService.getList(2).then(function (data) {
        if (Array.isArray(data) && data.length) {
          vm.pendingApprovals = data;
        }
      });

      _loadTrips();
    };

    this.logout = function () {
      LoginService.logout();
      $state.go('login');
      $window.location.reload();
    };
  }

  DashboardCtrl.$inject = ['$window', '$state', 'LoginService', 'TripService', 'ConnectionsService', 'LRNotification', '$timeout'];
  angular.module('view.dashboard', ['ui.router']).config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('dashboard', {
      url: '/?token',
      template: '<dashboard user="$resolve.user"/>',
      title: 'Dashboard',
      resolve: {
        user: function user(AuthService) {
          return AuthService.getUser();
        }
      }
    });
  }]).component('dashboard', {
    bindings: {
      user: '<'
    },
    controller: DashboardCtrl,
    templateUrl: 'views/dashboard/dashboard.html'
  });
})();